import { useEffect } from 'react'
// Styled
import { styled } from '@mui/material/styles'
// Components
import { Stack, Box, Typography } from '@mui/material'
import { MyAccountBackground } from '$common/my-account-background'
import { t } from '$i18n'
import { VERSION } from '$setup/version'
import { toLocale } from '$func/text'
import { MyAccountAppBar } from './my-account-app-bar'
import { MyAccountProfileInfo } from './my-account-profile-info'
import { MyAccountActions } from './my-account-actions'

const Root = styled(Box)(({ theme }) => ({
  height: '100%',
  backgroundColor: theme.palette.veryVeryLightGray,
  position: 'relative',
  overflow: 'hidden',
}))

const Body = styled(Stack)`
  height: 100%;
  padding: 0 10px 20px;
  position: relative;
  overflow: auto;
`

const Version = styled(Typography)`
  text-align: center;
  margin-top: 20px;
`

export const MyAccount = () => {
  return (
    <Root>
      <MyAccountBackground />
      <Body>
        <MyAccountAppBar />
        <MyAccountProfileInfo />
        <MyAccountActions />
        <Version variant="body2" color="gray">
          {`${t('changelogModal.version')} ${toLocale(VERSION)}`}
        </Version>
      </Body>
    </Root>
  )
}
